// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/images/ellipse342.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verified_main_container{
    min-height:100vh;
    background: linear-gradient(82deg, rgba(255, 255, 255, 0.20) -146.09%, rgba(255, 255, 255, 0.00) 58.97%), #100027;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: top center;
}



.data-container{
    height:100%;
    box-sizing: border-box;
}

.verify_custom_btn{
    padding:5px;
}
.verify_btn_txt{
    color: var(--Turquoise, #06EFC5);
    text-align: center;
    font-family: Open Sans;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.01031rem;
}
.verify_step_txt{
    color: var(--White, #FFF);
    text-align: center;
    font-family: Urbanist;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.0625rem;
    opacity: 0.4;
}

.v_cong_container{
    width:75%;
}

.v_acc_btn{
    padding: 0.625rem 1.25rem;
    margin:auto auto;
    border-radius: 4.9375rem;
    border: 0.5px solid #FFF;
    background: rgba(6, 239, 197, 0.70);
    box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.20);
}
.v_acc_btn_txt{
    color: var(--White, #FFF);
    padding:0px;
    text-align: center;
    font-family: Urbanist;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.0625rem;
}

.v_cong_txt{
    color: #11D4B1;
    text-align: center;
    font-family: Urbanist;
    font-size: 2.375rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.0625rem;
    text-transform: uppercase;
    
}
.v_subs_txt{
    color: var(--White, #FFF);
    text-align: center;
    font-family: Urbanist;
    font-size: 1.375rem;
    font-style: normal;
    font-weight: 500;
    line-height: 130%; /* 1.7875rem */
    letter-spacing: 0.0625rem;
}

.v_plan_btn{
    width:16.9375rem;
    margin:auto auto;
    display: inline-flex;
    padding: 1rem 2.75rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    border-radius: 0.625rem;
    background: var(--Turquoise, #06EFC5);
}
.v_plan_txt{
    color: #100027;
    text-align: center;
    font-family: Open Sans;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.01031rem;
}

.logo-position{
    position: absolute;
    top:3rem;
    left:5rem;
}
@media screen and (max-width:1200px) {
    .logo-position{
        top:3rem;
        left:2rem;
    }
    
}
@media screen and (max-width:768px) {
    .logo-position{
        display: none;
    }
    
}
@media screen and (max-width:476px) {
    .design-img-container img{
        width:80%;
    }
    .v_cong_txt{
        font-size: 2rem;
    }
    
}


.v_margin_top{
    margin-top:8rem;
    margin-bottom:4rem;
}

.mr-tp{
    margin-top:6.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/verified/verified.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iHAAiH;IACjH,yDAAwE;IACxE,4BAA4B;IAC5B,+BAA+B;AACnC;;;;AAIA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,wBAAwB;IACxB,wBAAwB;IACxB,mCAAmC;IACnC,gDAAgD;AACpD;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;;AAE7B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,cAAc;IACjC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI;QACI,QAAQ;QACR,SAAS;IACb;;AAEJ;AACA;IACI;QACI,aAAa;IACjB;;AAEJ;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".verified_main_container{\n    min-height:100vh;\n    background: linear-gradient(82deg, rgba(255, 255, 255, 0.20) -146.09%, rgba(255, 255, 255, 0.00) 58.97%), #100027;\n    background-image: url(\"../../../../public/assets/images/ellipse342.png\");\n    background-repeat: no-repeat;\n    background-position: top center;\n}\n\n\n\n.data-container{\n    height:100%;\n    box-sizing: border-box;\n}\n\n.verify_custom_btn{\n    padding:5px;\n}\n.verify_btn_txt{\n    color: var(--Turquoise, #06EFC5);\n    text-align: center;\n    font-family: Open Sans;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.01031rem;\n}\n.verify_step_txt{\n    color: var(--White, #FFF);\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: 0.0625rem;\n    opacity: 0.4;\n}\n\n.v_cong_container{\n    width:75%;\n}\n\n.v_acc_btn{\n    padding: 0.625rem 1.25rem;\n    margin:auto auto;\n    border-radius: 4.9375rem;\n    border: 0.5px solid #FFF;\n    background: rgba(6, 239, 197, 0.70);\n    box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.20);\n}\n.v_acc_btn_txt{\n    color: var(--White, #FFF);\n    padding:0px;\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: 0.0625rem;\n}\n\n.v_cong_txt{\n    color: #11D4B1;\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 2.375rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: 0.0625rem;\n    text-transform: uppercase;\n    \n}\n.v_subs_txt{\n    color: var(--White, #FFF);\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 1.375rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 130%; /* 1.7875rem */\n    letter-spacing: 0.0625rem;\n}\n\n.v_plan_btn{\n    width:16.9375rem;\n    margin:auto auto;\n    display: inline-flex;\n    padding: 1rem 2.75rem;\n    justify-content: center;\n    align-items: center;\n    gap: 0.625rem;\n    border-radius: 0.625rem;\n    background: var(--Turquoise, #06EFC5);\n}\n.v_plan_txt{\n    color: #100027;\n    text-align: center;\n    font-family: Open Sans;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.01031rem;\n}\n\n.logo-position{\n    position: absolute;\n    top:3rem;\n    left:5rem;\n}\n@media screen and (max-width:1200px) {\n    .logo-position{\n        top:3rem;\n        left:2rem;\n    }\n    \n}\n@media screen and (max-width:768px) {\n    .logo-position{\n        display: none;\n    }\n    \n}\n@media screen and (max-width:476px) {\n    .design-img-container img{\n        width:80%;\n    }\n    .v_cong_txt{\n        font-size: 2rem;\n    }\n    \n}\n\n\n.v_margin_top{\n    margin-top:8rem;\n    margin-bottom:4rem;\n}\n\n.mr-tp{\n    margin-top:6.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
